import {Injectable} from '@angular/core';
import {CanDeactivate} from '@angular/router';
import {AntragVersendenComponent} from '@common-ui-lib';

@Injectable()
export class AntragVersendenDeactivateGuard implements CanDeactivate<AntragVersendenComponent> {

  public canDeactivate(component: AntragVersendenComponent): boolean {
    return !component.sendPending;
  }
}
